import Swal from "sweetalert2"

export const QuestionAlert = ({ text }: { text: string }) => {
  return (
    Swal.fire({
      title: "Atenção",
      text: text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#5cb85c",
      cancelButtonColor: "#F27474",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim",
      
    }).then((result) => {
      if (result.isConfirmed) {
        return true
      }
      return false
    })
  )
}

